<template>
    <div>
        <pageLoader :showLoader="false" :checkDocState=false></pageLoader>
        <customModalDialog :settings="customModalSettings"></customModalDialog>
        <div v-if="!loaded"> Loading... </div>
        <div class="ServiceRequest" v-else v-bind:style="{ background: [getBackgroundColor()]}">
            <div class="Request_wrapper">
                <div class="content">
                    <div class="inner-content">
                        <div v-for="contentItem in getContentItems()" class="content-item">
                            <div v-if="shouldShowItem(contentItem)">
                                <div v-if="contentItem.type == 'changer'">
                                    <b-form-input type="text" placeholder="" class="form-control"
                                                  style="display: none;"
                                                  v-model="contentItem.value"></b-form-input>
                                </div>
                                <div v-if="contentItem.type == 'space'"
                                     :style="{
                                           'height': `${contentItem.height}px`,
                                     }"
                                >
                                </div>
                                <!-- logo -->
                                <div v-if="contentItem.type == 'logo' && (place_img.length != 0 || contentItem.value)"
                                     class="place">
                                    <div class="place_img">
                                        <img :src="contentItem.value || place_img" alt="place img" :style="{ 'aspect-ratio': contentItem.img_aspect_ratio}">
                                    </div>
                                </div>
                                <!-- title -->
                                <div v-if="contentItem.type == 'title'"
                                     class="main_title"
                                     :style="{
                                           'text-align': `${getLabelItemAlignment(contentItem)}`,
                                           'color': `${getLabelItemColor(contentItem)}`,
                                     }"
                                >{{ contentItem.value }}</div>
                                <!-- label -->
                                <div v-if="contentItem.type == 'label'"
                                    class="subtitle"
                                     :style="{
                                           'text-align': `${getLabelItemAlignment(contentItem)}`,
                                           'color': `${getLabelItemColor(contentItem)}`,
                                     }"
                                >{{ getLabelItemText(contentItem) }}</div>
                                <!-- selector -->
                                <div v-if="contentItem.type == 'selector'" class="input-wrapper additional">
                                    <label class="dropdown-label">{{ contentItem.label }}{{ contentItem.required ? '*' : '' }}</label>
                                    <b-dropdown
                                        :text="contentItem.value == '' ? contentItem.hint : contentItem.value"
                                        class="additional-dropdown"
                                        toggle-class="additional-dropdown-toggle">
                                        <b-dropdown-item v-for="item in contentItem.options" :key="item.id"
                                                         v-on:click="contentItem.value = item; refreshValidation()">
                                            <span> {{ item }}</span>
                                        </b-dropdown-item>
                                    </b-dropdown>
                                </div>
                                <!-- input -->
                                <div v-if="contentItem.type == 'input'" class="input-wrapper input">
                                    <b-form-input type="text" placeholder="" class="form-control"
                                                  v-model="contentItem.value" @input="refreshValidation()"
                                                  :maxlength="contentItem.max_length ? contentItem.max_length : 200"
                                    ></b-form-input>
                                    <label class="input-label">{{ contentItem.label }}{{ contentItem.required ? '*' : '' }}</label>
                                </div>
                                <!-- notes block -->
                                <div v-if="contentItem.type == 'notes'">
                                    <div class="input-wrapper notes">
                                        <b-form-input type="text" placeholder=" " ref="notes_input" class="form-control"
                                                      v-model="notes"
                                                      :maxlength="contentItem.max_length ? contentItem.max_length : 200"
                                        ></b-form-input>
                                        <label class="input-label">{{ contentItem.label }}</label>
                                        <recordAudioBtn :settings="recordAudioBtnSettings"></recordAudioBtn>
                                        <div @click="onAttachClick" v-if="true" class="comment_btn__wrapper photo"
                                             :style="{ opacity: [files.length == maxFiles ? '0.2' : '1']}">
                                            <img src="@/assets/icons/ic_photo.svg">
                                        </div>
                                    </div>
                                    <div class="preview" v-if="files.length > 0">
                                        <img v-for="(item, index) in files"
                                             :key="index"
                                             :src="item.url"
                                             @click="onFileClick(item)"/>
                                    </div>
                                    <div class="audio_wrapper" id='audio' v-for="(item, index) in recordedAudio" :key="index">
                                        <!--                            <img :src="item.url"/>-->
                                        <audio controls='controls' v-if="recordedAudio.length > 0">
                                            <source :src="audioLink">
                                        </audio>
                                        <div class="audio_delete" id="audio_delete" v-if="recordedAudio.length > 0"
                                             @click="deleteAudioClick">
                                            <img src="@/assets/icons/ic_trash.svg" alt="">
                                        </div>
                                    </div>
                                </div>
                                <!-- checkbox -->
                                <div
                                    v-if="contentItem.type == 'checkbox'"
                                    class="checkbox-wrapper">
                                    <b-form-checkbox v-model="contentItem.value" @input="refreshValidation()"></b-form-checkbox>
                                    <span @click="onCheckboxClick(contentItem)">{{ contentItem.label }}</span>
                                </div>
                                <!-- action_button -->
                                <div
                                    v-if="contentItem.type == 'action_button'"
                                    class="main_button"
                                    :style="{
                                           'background': `${getActionButtonBack(contentItem)}`,
                                           'color': `${getActionButtonTextColor(contentItem)}`,
                                     }"
                                     @click="onSendClick(contentItem)">
                                    <div>{{ contentItem.value }}</div>
                                </div>
                                <!-- scan_qrs_button -->
                                <div
                                    v-if="contentItem.type == 'scan_qrs_button'">
                                    <div
                                        class="scan_qrs_button"
                                        :style="{
                                           'background': `${getItemBack(contentItem)}`,
                                           'color': `${getItemColor(contentItem)}`,
                                     }"
                                        @click="onScanMoreQrsClick(contentItem)">
                                        <div>{{ contentItem.value }} {{ getScanMoreClicksCount(contentItem) }}</div>
                                    </div>
<!--                                    <div v-if="contentItem.qrs && contentItem.qrs.length > 0">
                                        QRs selected: {{ contentItem.qrs.length }}
                                    </div>-->
                                </div>
                                <!-- blocks -->
                                <div v-if="contentItem.type == 'blocks' && contentItem.rectangles">
                                    <div
                                        class="content__wrapper" v-for="(index) in Math.ceil(contentItem.rectangles.length / 2)"  :key="index">
                                        <div class="rectangle-wrapper left">
                                            <div class="rectangle" :class="{active: contentItem.rectangles[index * 2 - 2].active}"
                                                 :style="{
                                           'background': `${getRectBackground(contentItem, index * 2 - 2)}`,
                                           'border': `${getRectBorder(contentItem, index * 2 - 2)}`,
                                           'aspect-ratio': `${getRectAspectRatio(contentItem, index * 2 - 2)}`,
                                     }"
                                                 @click="onRectClick(contentItem, contentItem.rectangles[index * 2 - 2], index * 2 - 2)">
                                                <div v-if="showShowSldUserImage(contentItem, index * 2 - 2) && shouldShowRectCloseBtn(contentItem, index * 2 - 2)" class="rect_close_back"
                                                     :style="{ 'background': showShowSldUserImage(contentItem, index * 2 - 2) ? `${getBlocksScreenPrimaryColor(contentItem)}54` : 'none',}"></div>
                                                <img v-if="shouldShowRectCloseBtn(contentItem, index * 2 - 2)" class="rect_close"
                                                     src="@/assets/icons/rect_close_img.png" v-on:click.stop="onRectCloseClick(contentItem, contentItem.rectangles[index * 2 - 2], index * 2 - 2)">
                                                <inline-svg :src="getSldIcons(contentItem.rectangles[index * 2 - 2].icon, contentItem.rectangles[index * 2 - 2].active)"
                                                            v-if="shouldShowSldIcon(contentItem, index * 2 - 2)"
                                                            :fill="getSldIconColor(contentItem, index * 2 - 2)"  class="rectangle_img" />
                                                <img v-if="shouldShowCameraIcon(contentItem, index * 2 - 2)" class="rect_btn_img"
                                                     src="@/assets/icons/photo_btn_img.png">
                                                <inline-svg :src="require('../assets/icons/ic_check_bold.svg')"
                                                            v-if="shouldShowCheckIcon(contentItem, index * 2 - 2)"
                                                            :fill="getCheckIconColor(contentItem, index * 2 - 2)"  class="check_icon"
                                                            :style="{ 'max-width': `${getCheckIconMaxWidth(contentItem, index * 2 - 2)}`,}"
                                                />
                                                <div class="progress_loader_wrapper"
                                                     v-if="showShowSldUserImage(contentItem, index * 2 - 2) && getSldUserFile(contentItem, index * 2 - 2).isUploading"
                                                     :style="{ 'background': `${getBlocksScreenPrimaryColor(contentItem)}54`,}"><div class="progress_loader"/></div>
                                                <div :class="{active: contentItem.rectangles[index * 2 - 2].active,
                            'rectangle-text': contentItem.rectangles[index * 2 - 2].icon || (contentItem.rectangles[index * 2 - 2].active && !contentItem.rectangles[index * 2 - 2].no_camera),
                            'rectangle-text__noicon': !contentItem.rectangles[index * 2 - 2].icon && (!contentItem.rectangles[index * 2 - 2].active || contentItem.rectangles[index * 2 - 2].no_camera),
                            }"
                                                     :style="{ 'background': showShowSldUserImage(contentItem, index * 2 - 2) ? `${getBlocksScreenPrimaryColor(contentItem)}54` : 'none',
                                  'max-width': showShowSldUserImage(contentItem, index * 2 - 2) ? `80%` : '96%',
                                   'color': getRectLblColor(contentItem, index * 2 - 2), }">
                                                    {{ getTranslations(contentItem.rectangles[index * 2 - 2].text) }}
                                                </div>
                                                <div v-if="showShowSubtitle(contentItem, index * 2 - 2)" class="rectangle-subtitle">
                                                    {{ getTranslations(contentItem.rectangles[index * 2 - 2].subtitle) }}
                                                </div>
                                            </div>
                                        </div>
                                        <div class="rectangle-wrapper right" v-if="index * 2 - 1 < contentItem.rectangles.length">
                                            <div class="rectangle" :class="{active: contentItem.rectangles[index * 2 - 1].active}"
                                                 :style="{
                                           'background': `${getRectBackground(contentItem, index * 2 - 1)}`,
                                           'border': `${getRectBorder(contentItem, index * 2 - 1)}`,
                                           'aspect-ratio': `${getRectAspectRatio(contentItem, index * 2 - 1)}`,
                                     }"
                                                 @click="onRectClick(contentItem, contentItem.rectangles[index * 2 - 1], index * 2 - 1)">
                                                <div v-if="showShowSldUserImage(contentItem, index * 2 - 1) && shouldShowRectCloseBtn(contentItem, index * 2 - 1)" class="rect_close_back"
                                                     :style="{ 'background': showShowSldUserImage(contentItem, index * 2 - 1) ? `${getBlocksScreenPrimaryColor(contentItem)}54` : 'none',}"></div>
                                                <img v-if="shouldShowRectCloseBtn(contentItem, index * 2 - 1)" class="rect_close"
                                                     src="@/assets/icons/rect_close_img.png" v-on:click.stop="onRectCloseClick(contentItem, contentItem.rectangles[index * 2 - 1], index * 2 - 1)">
                                                <inline-svg :src="getSldIcons(contentItem.rectangles[index * 2 - 1].icon, contentItem.rectangles[index * 2 - 1].active)"
                                                            v-if="shouldShowSldIcon(contentItem, index * 2 - 1)"
                                                            :fill="getSldIconColor(contentItem, index * 2 - 1)"  class="rectangle_img" />
                                                <img v-if="shouldShowCameraIcon(contentItem, index * 2 - 1)" class="rect_btn_img"
                                                     src="@/assets/icons/photo_btn_img.png">
                                                <inline-svg :src="require('../assets/icons/ic_check_bold.svg')"
                                                            v-if="shouldShowCheckIcon(contentItem, index * 2 - 1)"
                                                            :fill="getCheckIconColor(contentItem, index * 2 - 1)"  class="check_icon"
                                                            :style="{ 'max-width': `${getCheckIconMaxWidth(contentItem, index * 2 - 1)}`,}"
                                                />
                                                <div class="progress_loader_wrapper"
                                                     v-if="showShowSldUserImage(contentItem, index * 2 - 1) && getSldUserFile(contentItem, index * 2 - 1).isUploading"
                                                     :style="{ 'background': `${getBlocksScreenPrimaryColor(contentItem)}54`,}"><div class="progress_loader"/></div>
                                                <div :class="{active: contentItem.rectangles[index * 2 - 1].active,
                            'rectangle-text': contentItem.rectangles[index * 2 - 1].icon || (contentItem.rectangles[index * 2 - 1].active && !contentItem.rectangles[index * 2 - 1].no_camera),
                            'rectangle-text__noicon': !contentItem.rectangles[index * 2 - 1].icon && (!contentItem.rectangles[index * 2 - 1].active || contentItem.rectangles[index * 2 - 1].no_camera),
                            }"
                                                     :style="{ 'background': showShowSldUserImage(contentItem, index * 2 - 1) ? `${getBlocksScreenPrimaryColor(contentItem)}54` : 'none',
                                  'max-width': showShowSldUserImage(contentItem, index * 2 - 1) ? `80%` : '96%',
                                   'color': getRectLblColor(contentItem, index * 2 - 1), }">
                                                    {{ getTranslations(contentItem.rectangles[index * 2 - 1].text) }}
                                                </div>
                                                <div v-if="showShowSubtitle(contentItem, index * 2 - 1)" class="rectangle-subtitle">
                                                    {{ getTranslations(contentItem.rectangles[index * 2 - 1].subtitle) }}
                                                </div>
                                            </div>
                                        </div>
                                        <div class="rectangle-wrapper right" v-else>

                                        </div>
                                    </div>
                                </div>

                                <!--  -->

                            </div>
                            <div v-else-if="contentItem.type == 'logo'" style="margin-top: 8px;"></div>
                        </div>


                        <profileIconNew :settings="profileIconSettings" v-if="showProfileIcon"></profileIconNew>

                        <input
                            style="display: none"
                            type="file"
                            @change="onFileSelected"
                            ref="fileInput"
                            accept="image/png, image/jpeg"
                            multiple>
                        <input
                            style="display: none"
                            type="file"
                            @change="onFileSelected"
                            ref="fileInputOnlyPhoto"
                            accept="image/png, image/jpeg"
                            capture="camera">
                    </div>
                </div>
            </div>
        </div>
        <div class="popupModal" :class="{active: selectedFile != null}">
            <div class="popupModal__wrapper" @mousedown='underlayClick'>
                <div class="popupModal__content" id="popupModal__content">
                    <div class="close-icon__wrapper">
                            <span class="close-icon" @click="selectedFile = null">
                                <img src="@/assets/icons/ic_close_white.svg">
                            </span>
                    </div>
                    <div class="photo-modal__wrapper">
                        <div class="photo-modal__image">
                            <img v-if="selectedFile" :src="selectedFile.url"/>
                        </div>
                    </div>
                    <div class="photo-modal__buttons">
                        <div class="photo-modal__delete" @click="onDeleteImageClick">
                            {{ translate('RemovePhoto') }}
                        </div>
                    </div>

                </div>
            </div>
        </div>
        <QRItemsScanner :settings="qrScannerSettings"></QRItemsScanner>
    </div>
</template>

<script>
import geoLocationMixin from "@/mixins/geoLocationMixin";
import errorMixin from '@/mixins/errorMixin';
import {mapActions, mapMutations, mapState} from 'vuex';
import customModalDialog from '@/components/widgets/customModalDialog';
import QRItemsScanner from '@/components/widgets/QRItemsScanner';
import profileIconNew from "./voteFlow/widgets/profileIconNew.vue";
import recordAudioBtn from "@/components/widgets/recordAudioBtn.vue";
import pageLoader from "@/components/widgets/pageLoader";
import logAnalyticsEvent from '@/helpers/analytics'
import "@/assets/css/popapModal.css";
import InlineSvg from 'vue-inline-svg';

export default {
    mixins: [mixin, geoLocationMixin, errorMixin],
    components: {
        customModalDialog, profileIconNew, recordAudioBtn, InlineSvg,
        QRItemsScanner,
        pageLoader,
    },
    data() {
        return {
            requestType: 'pickup',
            srvId: null,
            fullConfig: null,
            loaded: false,
            config: {},
            place_img: '',
            question: null,
            showProfileIcon: false,
            profileIconSettings: {
                longTapForLogout: false,
                afterLogoutHandler: this.afterLogout,
                showAdminMenu: true,
                items: [],
            },
            inputIsValid: false,
            notes: '',
            name: '',
            phone: '',
            confirmCharge: false,
            recordInProgress: false,

            recordAudioBtnSettings: {
                recordInProgressBool: this.recordInProgress,
                startRecord: this.recordAudio,
                stopRecord: this.stopRecordAudioClick
            },

            userLocation: {
                lat: 0,
                lng: 0,
                accuracy: 0
            },
            files: [],
            photoSize: 20, // megabytes
            maxFiles: 5,
            selectedFile: null,
            customModalSettings: {},
            qrScannerSettings: {},
            recorder: null,
            mediaStream: null,
            recordedAudio: [],
            audioLink: null,
            sldIndexForImage: null,
            cameraPaused: false,
        }
    },
    computed: {
        ...mapState({
            accessToken: state => state.auth.accessToken,
        })
    },
    watch: {

    },
    async mounted() {
        this.requestType = this.$route.params.type
        await this.fetchConfig()
        // this.focusInputWithTimeout('name_input')
    },
    methods: {
        ...mapMutations({
            setProgressBarTag: 'setProgressBarTag',
            removeKeys: 'auth/removeKeys',
        }),
        ...mapActions({
            getInitialData: 'serviceRequest/getInitialData',
            addRequest: 'serviceRequest/addRequest',
            sendRemoteLogAction: 'serviceRequest/sendLog',
        }),
        getLabelItemText(contentItem) {
            return contentItem.value
                .replace('@location', this.question.placement)
                .replace('@asset_id', this.question.asset_id || '')
                .replace('@q_id', this.question.id || '')
        },
        getLabelItemAlignment(contentItem) {
            if (!contentItem.align) return "center"
            return contentItem.align
        },
        getLabelItemColor(contentItem) {
            if (!contentItem.color || !contentItem.color.startsWith("#")) return "#000000"
            return contentItem.color
        },
        onQRDetected(dsfsdf) {

        },
        getContentItems() {
            return this.config.content || []
        },
        getBackgroundColor() {
            if (this.config.background) {
                return this.config.background
            } else {
                return '#d5d5d5'
            }
        },
        getActionButtonBack(contentItem) {
            if (this.inputIsValid) {
                return contentItem.active_back || '#7d7d7d'
            } else {
                return contentItem.inactive_back || '#d7d7d7'
            }
        },
        getActionButtonTextColor(contentItem) {
            if (this.inputIsValid) {
                return contentItem.active_color || '#ffffff'
            } else {
                return contentItem.inactive_color || '#ffffff'
            }
        },
        getItemBack(contentItem) {
            return contentItem.back || '#7d7d7d'
        },
        getItemColor(contentItem) {
            return contentItem.color || '#ffffff'
        },
        refreshValidation() {
            var fieldsValid = true
            let contentItems = this.getContentItems()
            console.log('refreshValidation:', contentItems)
            for (let i = 0; i < contentItems.length; i++) {
                let contentItem = contentItems[i]
                if(contentItem.show === false || !contentItem.required) continue

                if(contentItem.type == 'input' || contentItem.type == 'selector') {
                    if(contentItem.value == '') {
                        console.log('input or selector empty')
                        fieldsValid = false
                        break
                    }
                } else if(contentItem.type == 'checkbox') {
                    if(!contentItem.value) {
                        console.log('checkbox empty')
                        fieldsValid = false
                        break
                    }
                } else if(contentItem.type == 'blocks') {
                    let anySelectedIndex = contentItem.rectangles.findIndex(item => item.active)
                    if(anySelectedIndex < 0) {
                        console.log('blocks empty')
                        fieldsValid = false
                        break
                    }
                }
            }
            this.inputIsValid = fieldsValid
        },
        async fetchConfig() {
            try {
                const response = await this.getInitialData({
                    guid: this.$route.params.questionId,
                    type: this.$route.params.type
                })
                this.srvId = response.srv_id
                this.fullConfig = response.config
                this.place_img = response.place_img_url ? response.place_img_url : ''
                this.question = response.question
                console.log(response)
                this.applyCurrentConfig()
            } catch (error) {
                console.log(error)
                switch (error.data.error.code) {
                    case 1021: //at least pin access required
                        this.navigateToServiceRequestAuth()
                        break;
                    case 1022: //access denied (current user has no access to this question)
                        this.navigateToServiceRequestNoAccess()
                        break;
                }
            }
        },
        navigateToServiceRequestAuth() {
            this.removeKeys()
            this.$router.push({name: 'ServiceRequestAuth', params: {questionId: this.$route.params.questionId, type: this.$route.params.type}})
        },
        navigateToServiceRequestNoAccess() {
            this.$router.push({name: 'ServiceRequestNoAccess', params: {questionId: this.$route.params.questionId, type: this.$route.params.type}})
        },
        afterLogout() {
            this.navigateToServiceRequestAuth()
        },
        showContactFields() {
            return !this.config.hide_contact_fields
        },
        applyCurrentConfig() {
            console.log(`this.fullConfig this.requestType:${this.requestType}:`, this.fullConfig)
            var config = this.fullConfig[this.requestType] ? this.fullConfig[this.requestType] : {}
            if(config.redirect && config.redirect.link) {
                window.location.replace(config.redirect.link);
                return
            }
            if(config.ask_gps || (config.settings && config.settings.ask_gps)) { //todo. Compatibility - remove config.ask_gps later
                this.initFetchLocationFlow()
            }
            config.editorValue = 'a'
            config.content = config.content.sort(function (q1, q2) {
                return q1.order - q2.order;
            });
            let thiz = this
            config.content.forEach(function (contentItem) {
                if(contentItem.type == 'input') {
                    if(contentItem.store_locally) {
                        contentItem.value = localStorage.getItem(contentItem.tag) || ''
                    }
                    if(contentItem.tag == 'placement') {
                        contentItem.value = thiz.question.placement || ''
                    }
                    if(contentItem.tag == 'asset_id') {
                        contentItem.value = thiz.question.asset_id || ''
                    }
                } else if(contentItem.type == 'blocks') {
                    thiz.getSecondLevelDetailsItemsAction(contentItem)
                } else if(contentItem.type == 'scan_qrs_button' && contentItem.qrs == null) {
                    contentItem.qrs = []
                }
                //todo
            })
            config.content.push({type: 'changer', value: 'a'})
            console.log('initial setup:', config)
            this.config = config
            this.refreshValidation()

            let showProfileIcon = true
            if(config.settings && config.settings.profile) {
                if(config.settings.profile.show_admin_menu != null) {
                    this.profileIconSettings.showAdminMenu = config.settings.profile.show_admin_menu
                }
                if(config.settings.profile.show != null) {
                    showProfileIcon = config.settings.profile.show
                }
                if(config.settings.profile.items) {
                    this.profileIconSettings.items = config.settings.profile.items
                }

            }
            this.showProfileIcon = showProfileIcon
            this.loaded = true
        },
        getSecondLevelDetailsItemsAction(contentItem) {
            let checkRectanglesActive = contentItem
            console.log(`checkRectanglesActive: ${checkRectanglesActive})`)
            contentItem.rectangles = this.prepareRectangles(checkRectanglesActive.blocks)
        },
        prepareRectangles(items) {
            for (let i = 0; items.length > i; i++) {
                items[i].active = false
                items[i].file = null
            }
            return JSON.parse(JSON.stringify(items))
        },
        getTranslations(key) {
            return this.translate(key)
        },
        getSldIcons(icon, active) {
            console.log(`getSldIcons: ${icon}`)
            return `https://api.air-vote.com/api/sec-level-images/${icon}`
        },
        checkAssetIdChanged() {
            let assetIdInput = this.getContentItems().find(contentItem => contentItem.type == 'input' && contentItem.tag == 'asset_id')
            return {
                changed: assetIdInput == null ? false : assetIdInput.value != this.question.asset_id,
                label: assetIdInput == null ? null : assetIdInput.label
            }
        },
        showShowSldUserImage(contentItem, index) {
            return contentItem.rectangles[index].active && this.getSldUserImage(contentItem, index)
        },
        showShowSubtitle(contentItem, index) {
            return contentItem.rectangles[index].subtitle && !contentItem.rectangles[index].icon && (!contentItem.rectangles[index].active || contentItem.rectangles[index].no_camera)
        },
        getRectBackground(contentItem, index) {
            if(contentItem.rectangles[index].active && this.getSldUserImage(contentItem, index)) {
                return `url('${this.getSldUserImage(contentItem, index) }')`
            } else if(contentItem.rectangles[index].active && contentItem.rectangles[index].no_camera) {
                return `#ffffff`
            } else if(contentItem.rectangles[index].active) {
                return this.getBlocksScreenSelectedBlockBack(contentItem)
            } else {
                return ''
            }
        },
        getCheckIconColor(contentItem) {
            return contentItem.check_color || contentItem.primary_color
        },
        getRectBorder(contentItem, index) {
            if(contentItem.rectangles[index].active && contentItem.rectangles[index].no_camera) {
                return `3px solid ${this.getBlocksScreenPrimaryColor(contentItem)}`
            } else {
                return '1px solid rgb(0 0 0 / 0.1)'
            }
        },
        getRectAspectRatio(contentItem, index) {
            return contentItem.aspect_ratio || 1
        },
        getCheckIconMaxWidth(contentItem, index) {
            if((contentItem.aspect_ratio || 1) > 1) {
                return '25px'
            } else {
                return ''
            }
        },
        getSldUserImage(contentItem, index) {
            let file = contentItem.rectangles[index].file
            if(file) {
                return file.url
            } else {
                return null
            }
        },
        shouldShowCameraIcon(contentItem, index) {
            return contentItem.rectangles[index].active
                && !this.getSldUserImage(contentItem, index)
                && !contentItem.rectangles[index].no_camera
        },
        shouldShowRectCloseBtn(contentItem, index) {
            return contentItem.rectangles[index].active
                && !this.isSldUserFileUploading(contentItem, index)
                && !contentItem.rectangles[index].no_camera
        },
        shouldShowSldIcon(contentItem, index) {
            return contentItem.rectangles[index].icon
                && (!contentItem.rectangles[index].active || contentItem.rectangles[index].no_camera)
        },
        shouldShowCheckIcon(contentItem, index) {
            return contentItem.rectangles[index].active
                && contentItem.rectangles[index].no_camera
        },
        getCheckIcon() {
            return '@/assets/icons/ic_check_bold.svg'
        },
        isSldUserFileUploading(contentItem, index) {
            return contentItem.rectangles[index].file && contentItem.rectangles[index].file.isUploading
        },
        getSldUserFile(contentItem, index) {
            return contentItem.rectangles[index].file
        },
        onRectCloseClick(contentItem, item, index) {
            if(item.active) {
                console.log(`onRectCloseClick for sld ${index} contentItem ${contentItem.report_tag} :`, item)
                logAnalyticsEvent(`vs_block_uncheck_clk`)
                this.uncheckRect(contentItem, item)
                this.sendLog('picture_removed', {
                    ci_tag: contentItem.tag,
                    sld: contentItem.rectangles[index].text }
                )
            }
            this.updateRectsRendering()
            this.refreshValidation()
        },
        uncheckRect(contentItem, item) {
            item.active = false
            this.handleAnswerAction(item)
            // this.detachPhoto(item.file.uploadedFile.uid)
            item.file = null
        },
        onRectClick(contentItem, item, index) {
            console.log(`onRectClick: ${index} contentItem: ${contentItem.report_tag}`)
            if(item.active) {
                let userFile = this.getSldUserFile(contentItem, index)
                if(userFile) {
                    if(userFile.isUploading){
                        this.sendLog('active_block_with_loading_photo_click')
                    } else {
                        this.sendLog('active_block_with_photo_click')
                        // this.selectedFile = userFile
                    }
                } else {
                    if(item.no_camera) {
                        this.uncheckRect(contentItem, item)
                        this.sendLog('block_unselected', {
                                ci_tag: contentItem.tag,
                                sld: contentItem.rectangles[index].text,
                            }
                        )
                    } else {
                        this.sendLog('block_attach_img_click', {
                                ci_tag: contentItem.tag,
                                sld: contentItem.rectangles[index].text,
                            }
                        )
                        this.attach(contentItem, index)
                    }
                }
            } else {
                item.active = !item.active
                let maxSelectedCount = contentItem.selected_count_max
                let selectedCount = contentItem.rectangles.filter((obj) => obj.active).length
                if (maxSelectedCount != 0 && selectedCount > maxSelectedCount) {
                    item.active = false
                    this.showErrorModal(this.translate('level2_maxCount', [maxSelectedCount]))
                } else {
                    if(this.shouldAutoOpenCamera(contentItem, item)) {
                        this.sldIndexForImage = {
                            index: index,
                            contentItem: contentItem
                        }
                        this.$refs.fileInputOnlyPhoto.click()
                    }
                }
                console.log(item.active)
                logAnalyticsEvent(`vs_block_check_clk`)
                this.handleAnswerAction(item)
                this.sendLog('block_selected', {
                        ci_tag: contentItem.tag,
                        sld: contentItem.rectangles[index].text,
                    }
                )
            }
            this.updateRectsRendering()
            this.refreshValidation()
        },
        updateRectsRendering() {
            this.config.content.forEach(function (contentItem) {
                if(contentItem.type == 'changer') {
                    contentItem.value = `${new Date().getMilliseconds()}`
                }
            })
        },
        shouldAutoOpenCamera(contentItem, item) {
            if(item.no_camera) return false
            if(item.auto_open_camera == null) {
                if(contentItem.auto_open_camera != null) {
                    return contentItem.auto_open_camera
                } else {
                    return false
                }
            } else {
                return item.auto_open_camera
            }
        },
        async handleAnswerAction(item) {
            //todo?
            // let data = {
            //     vote_uid: this.currentVote.uid,
            //     option: this.getTranslations(item.value),
            //     isDelete: !item.active,
            // }
            // try {
            //     let response = await this.handleAnswer(data)
            //     if (response.success) console.log(response)
            //     if (item.active) {
            //         logAnalyticsEvent(`vs_block_check_success`)
            //     } else {
            //         logAnalyticsEvent(`vs_block_uncheck_success`)
            //     }
            // } catch (error) {
            //     this.showErrorModal(error.data.error.message)
            //     if (item.active) {
            //         logAnalyticsEvent(`vs_block_check_send_error`)
            //     } else {
            //         logAnalyticsEvent(`vs_block_uncheck_send_error`)
            //     }
            // }
        },
        getRectLblColor(contentItem, index) {
            if(contentItem.rectangles[index].active && contentItem.rectangles[index].no_camera) {
                return contentItem.primary_color
            } else if(contentItem.rectangles[index].active) {
                return '#ffffff'
            } else {
                return contentItem.primary_color
            }
        },
        getSldIconColor(contentItem, index) {
            if(contentItem.rectangles[index].active && contentItem.rectangles[index].no_camera) {
                // return '#ffffff'
                return contentItem.primary_color
            } else {
                return contentItem.primary_color
            }
        },
        getBlocksScreenPrimaryColor(contentItem) {
            return contentItem.primary_color
        },
        getBlocksScreenSelectedBlockBack(contentItem) {
            return contentItem.selected_block_back || contentItem.primary_color
        },
        getCurrentBlocksConfig() {
            // return this.config.blocks_config
            return []
        },
        onCheckboxClick(contentItem) {
            contentItem.value = !contentItem.value
            this.refreshValidation()
        },
        async sendLog(action, additionalData = null) {
            await this.sendRemoteLogAction({
                srv_id: this.srvId,
                action: action,
                additional_data: additionalData,
            })
        },
        async initFetchLocationFlow() {
            try {
                let attempt = 1
                this.sendLog('gps_requested', {'attempt': attempt,})
                let position = await this.fetchUserLocation(60000*5)
                await this.applyNewGPS(position)
                this.logGPSReceived(position, attempt)
                let time = (new Date()).getTime()
                let allowedDiffSeconds = 30
                let fetchLocation = (time - position.timestamp > allowedDiffSeconds*1000) || position.coords.accuracy > 20
                while(fetchLocation) {
                    attempt++
                    this.sendLog('gps_requested', {'attempt': attempt,})
                    position = await this.fetchUserLocation(30000)
                    await this.applyNewGPS(position)
                    this.logGPSReceived(position, attempt)
                    fetchLocation = (time - position.timestamp > allowedDiffSeconds*1000) || position.coords.accuracy > 20 || attempt > 20
                }
            } catch (e) {
                console.log(`kek error:`, e)
                let type = ''
                let logData = {}
                switch (e.code) {
                    case 1: {
                        type = 'gps_disallowed'
                        logData.error = `error code: ${e.code} | ${JSON.stringify(e)}`
                        break;
                    }
                    case 2: {
                        type = 'gps_unsupported'
                        logData.error = `error code: ${e.code} | ${JSON.stringify(e)}`
                        break;
                    }
                    case 3: {
                        type = 'gps_timeout'
                        logData.error = `error code: ${e.code} | ${JSON.stringify(e)}`
                        break;
                    }
                }
                this.sendLog(type, logData)
            }
        },

        async logGPSReceived(position, attempt) {
            this.sendLog('gps_received',
                {
                    attempt: attempt,
                    lat: position.coords.latitude,
                    lng: position.coords.longitude,
                    accuracy: Math.round(position.coords.accuracy),
                    ts: (new Date(position.timestamp)).toISOString(),
                }
            )
        },

        async applyNewGPS(position) {
            this.userLocation = {
                lat: position.coords.latitude,
                lng: position.coords.longitude,
                accuracy: Math.round(position.coords.accuracy),
            }
        },

        onFileSelected(event) {
            console.log(`onFileSelected files:`, event.target.files)
            for (let i = 0; event.target.files.length > i; i++) {
                let selectedFile = event.target.files[i];
                if (selectedFile.type != 'image/png' && selectedFile.type != 'image/jpeg') {
                    this.showErrorModal(this.translate('WrongFormat'))
                } else if ((selectedFile.size >= (this.photoSize * 1048576))) {
                    this.showErrorModal(this.translate('PhotoOverweight', [this.photoSize]))
                } else {
                    if (this.files.length == this.maxFiles) {
                        this.$refs.fileInput.value = ''
                        // this.$refs.fileInputOnlyPhoto.value = ''
                        this.showErrorModal(this.translate('max_attach_photos_count_error', [this.maxFiles]))
                        return
                    }
                    let sldIndex = this.sldIndexForImage
                    this.sldIndexForImage = null
                    if(sldIndex != null) {
                        this.sendLog('picture_chosen', {
                            ci_tag: sldIndex.contentItem.tag,
                            sld: sldIndex.contentItem.rectangles[sldIndex.index].text }
                        )
                    }
                    let file = {
                        file: selectedFile,
                        url: URL.createObjectURL(selectedFile),
                        isUploading: false,
                        uploadedFile: null,
                    }
                    if(sldIndex != null) {
                        console.log(`created file for sld ${sldIndex.index} :`, file)
                        sldIndex.contentItem.rectangles[sldIndex.index].file = file
                        // this.attachPhoto(file, this.rectangles[sldIndex].text)
                    } else {
                        console.log(`added comments file`, file)
                        this.files.push(file)
                    }
                    this.updateRectsRendering()
                }
            }
            console.log(`files`, this.files)
            this.$refs.fileInput.value = ''
            // this.$refs.fileInputOnlyPhoto.value = ''
        },
        attach(contentItem, sldIndexForImage = null) {
            this.sldIndexForImage = {
                index: sldIndexForImage,
                contentItem: contentItem
            }
            if (this.files.length < this.maxFiles || sldIndexForImage) {
                this.$refs.fileInput.click()
            }
        },
        attachOnlyPhoto() {
            if (this.files.length < this.maxFiles) {
                this.$refs.fileInputOnlyPhoto.click()
            }
        },
        onAttachClick() {
            if (this.files.length < this.maxFiles) this.$refs.fileInput.click()
            this.sendLog('attach_photo_btn_click', {'max_files reached': this.files.length < this.maxFiles,})
        },
        onFileClick(item) {
            this.selectedFile = item
        },
        submitCheck() {
            console.log(this.driverInfo)
        },
        focusInputWithTimeout(ref) {
            setTimeout(() => {
                this.$refs[ref].focus()
            }, 200);
        },
        onDeleteImageClick() {
            if (this.selectedFile == null) return
            this.files = this.files.filter(item => {
                return item.url != this.selectedFile.url
            })
            this.selectedFile = null
        },
        underlayClick(e) {
            if (this.isClickOutOfBlock('popupModal__content', e.target)) {
                console.log(`underlayClick`)
                this.selectedFile = null
            }
        },
        recordAudio() {
            logAnalyticsEvent('al_audio_rec_clk')
            this.sendLog('attach_audio_btn_click')
            let device = navigator.mediaDevices.getUserMedia({audio: true});
            device.then((stream) => {
                this.recorder = new MediaRecorder(stream);
                this.mediaStream = stream
                this.recordInProgress = true
                this.recordAudioBtnSettings.recordInProgressBool = true
                this.recordAction()
                this.recorder.start();
                setTimeout(() => {
                    this.stopRecording()
                }, 60000);
            })
        },
        recordAction() {
            if (this.recordedAudio.length > 0) {
                this.recordedAudio.shift()
            }
            this.recorder.ondataavailable = (e) => {
                this.recordedAudio.push(e.data)
                let blob = new Blob(this.recordedAudio, {type: this.recorder.mimeType,});
                this.audioLink = URL.createObjectURL(blob)
            };
        },
        stopRecordAudioClick() {
            logAnalyticsEvent('al_audio_rec_stop_clk')
            this.sendLog('audio_record_stop_click')
            this.stopRecording()
        },
        stopRecording() {
            this.sendLog('audio_recorded')
            this.recordInProgress = false
            this.recordAudioBtnSettings.recordInProgressBool = false
            this.recorder.stop();
            if (this.mediaStream) this.mediaStream.getTracks().forEach(track => track.stop());
        },
        deleteAudioClick() {
            this.recordedAudio.shift()
            logAnalyticsEvent('al_audio_rec_remove_clk')
            this.sendLog('audio_removed')
        },

        getScanMoreClicksCount(contentItem) {
            let initialCount = contentItem.initial_count || 0
            if(initialCount > 0 || (contentItem.qrs && contentItem.qrs.length > 0)) {
                return '(' + (contentItem.qrs.length + initialCount) + ')'
            } else {
                return ""
            }
        },

        onScanMoreQrsClick(contentItem) {
            if(contentItem.tag == 'sl_additional_qrs') {
                let assetIdChanged = this.checkAssetIdChanged()
                if (assetIdChanged.changed) {
                    this.showErrorModal(`Scanning more items is unavailable when '${assetIdChanged.label}' changed`)
                    return
                }
            }
            this.qrScannerSettings = {
                data: "data",
                onFinishHandler: this.onQRsSelected.bind(null, contentItem),
            }
        },
        onQRsSelected(contentItem, qrs) {
            console.log(`onQrsSelected contentItem:`, contentItem)
            console.log(`onQrsSelected qrs:`, qrs)
            qrs.forEach((qr) => {
                contentItem.qrs.push({
                    value: qr,
                })
            })
            this.updateRectsRendering()
        },

        async onSendClick(contentItem) {
            if (!this.inputIsValid) {
                if(contentItem.inactive_message && contentItem.inactive_message != '') {
                    this.showErrorModal(contentItem.inactive_message, {duration: 1000})
                }
                return
            }
            if (this.recordInProgress) {
                this.stopRecording()
            }

            let nameDefault = ''
            let phoneDefault = ''

            var additionalData = {};
            let images = this.files.map(item => item.file)
            let contentItems = this.getContentItems()
            for (let i = 0; i < contentItems.length; i++) {
                let contentItem = contentItems[i]
                if(!this.shouldShowItem(contentItem)) continue

                if(contentItem.type == 'input'
                    || contentItem.type == 'selector') {

                    if(contentItem.required || contentItem.value != '') {
                        if(contentItem.tag == 'name_default') {
                            nameDefault = contentItem.value
                        } else if(contentItem.tag == 'phone_default') {
                            phoneDefault = contentItem.value
                        } else {
                            additionalData[contentItem.tag] = {
                                value: contentItem.value,
                                tag: contentItem.tag,
                                label: contentItem.label,
                                required: contentItem.required,
                                report_tag: contentItem.report_tag,
                            }
                        }
                    }
                    if(contentItem.store_locally) {
                        localStorage.setItem(contentItem.tag, contentItem.value)
                    }
                } else if(contentItem.type == 'checkbox') {
                    additionalData[contentItem.tag] = {
                        value: contentItem.value,
                        tag: contentItem.tag,
                        label: contentItem.label,
                        required: contentItem.required,
                        report_tag: contentItem.report_tag,
                    }
                    if(contentItem.store_locally) {
                        localStorage.setItem(contentItem.tag, contentItem.value)
                    }
                }  else if(contentItem.type == 'scan_qrs_button') {
                    additionalData[contentItem.tag] = {
                        qrs: contentItem.qrs,
                        tag: contentItem.tag,
                        label: contentItem.label,
                        required: contentItem.required,
                        report_tag: contentItem.report_tag,
                    }
                    if(contentItem.tag == 'sl_additional_qrs' && contentItem.qrs && contentItem.qrs.length > 0) {
                        let assetIdChanged = this.checkAssetIdChanged()
                        if(assetIdChanged.changed) {
                            this.showErrorModal(`Submitting for multiple QRs is unavailable when '${assetIdChanged.label}' changed`)
                            return
                        }
                    }
                } else if(contentItem.type == 'blocks') {
                    let problemsChosen = []
                    contentItem.rectangles.forEach(function (block) {
                        if(block.active) {
                            problemsChosen.push(block.value)
                            if(block.file && block.file.file) {
                                images.push(block.file.file)
                            }
                        }
                    })
                    if(problemsChosen.length > 0) {
                        additionalData[contentItem.tag] = {
                            value: problemsChosen.join(', '),
                            values: problemsChosen,
                            tag: contentItem.tag,
                            label: '',
                            required: contentItem.required,
                            report_tag: contentItem.report_tag,
                        }
                    }
                }
            }

            const body = {
                srv_id: this.srvId,
                notes: this.notes,
                name: nameDefault,
                phone: phoneDefault,
                question_guid: this.$route.params.questionId,
                type: this.requestType,
                location: this.userLocation,
                images: images,
                audio: this.recordedAudio.length > 0 ? new Blob(this.recordedAudio, {type: this.recorder.mimeType,}) : null,
                data: additionalData
            }
            try {
                this.setProgressBarTag({
                    show: true,
                    tag: 'add_service_request'
                })
                const response = await this.addRequest(body)
                let tag = 'dr' + response.service_request.id * 100
                localStorage.setItem(tag, this.getSuccessText());
                this.$router.push({name: 'ServiceRequestSuccess', query: {t: tag}})
            } catch (error) {
                console.log(error)
                if (error.data.error.code == 1227) {
                    this.showErrorModal("Scanning multiple items is unavailable when asset id changed")
                } else {
                    this.showErrorModal(error.data.error.message)
                }
            } finally {
                this.setProgressBarTag({
                    show: false,
                    tag: 'add_service_request'
                })
            }
        },
        getSuccessText() {
            return this.config.success_screen && this.config.success_screen.text ? this.config.success_screen.text : this.translate('serviceRequest_successText')
        },
        shouldShowItem(contentItem) {
            let showRules = contentItem.show_rules
            let showRulesEmpty = showRules == null || showRules.rules == null || showRules.rules.length == 0
            if(showRulesEmpty) {
                return contentItem.show == null || contentItem.show == true
            }
            let rules = showRules.rules
            let rulesType = showRules.type || 'and'
            let values = []
            for (var i = 0; i < rules.length; i++) {
                let rule = rules[i]
                if(rule.type == 'field') {
                    let targetItem = this.findContentItemByTag(rule.target)
                    if(targetItem == null) continue
                    if(rule.rule == 'equals') {
                        let result = rule.value == targetItem.value
                        values.push(result)
                    } else if (rule.rule == 'has_item_selected') {
                        if(targetItem.type == 'blocks') {
                            let selectedValues = this.getBlocksSelectedItemsValues(targetItem)
                            let result = selectedValues.some(value => value == rule.value)
                            values.push(result)
                        } else {
                            //can not be here now
                        }
                    } else {
                        //add more later
                    }
                } else {
                    //todo add more types later
                }
            }

            if(values.length == 0) {
                return false
            }
            if(rulesType == 'and') {
                return values.every(value => value === true);
            } else {
                return values.some(value => value === true);
            }
        },
        findContentItemByTag(tag) {
            return this.getContentItems().find(contentItem => contentItem.tag == tag)
        },
        getBlocksSelectedItemsValues(contentItem) {
            let itemsChosen = []
            contentItem.rectangles.forEach(function (block) {
                if(block.active) {
                    itemsChosen.push(block.value)
                }
            })
            return itemsChosen
        }
    }

}
</script>

<style>
.dropdown-menu {
    z-index: 9999999 !important;
}

.ServiceRequest .comment_btn__wrapper.audio {
    right: 46px;
    bottom: 9px;
}

.ServiceRequest #container {
    bottom: -2px;
}

.ServiceRequest .spin {
    bottom: 5px;
    right: 40px;
}

.additional-dropdown {

}
.additional-dropdown li {
    width: 100%;
}
.additional-dropdown-toggle {
    background: white !important;
    border: 1px solid black;
    color: black !important;
}
.additional-dropdown-toggle::after {
    margin-left: 10px;
}


</style>
<style scoped>
.ServiceRequest {
    display: flex;
    padding-top: 16px;
    padding-bottom: 36px;
    padding-left: 16px;
    padding-right: 16px;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    min-height: 100%;
}

.Request_wrapper {
    position: relative;
    width: 100%;
    display: flex;
}

.content {
    max-width: 500px;
    width: 100%;
    position: initial;
    border-radius: 10px;
    display: flex;
    flex-direction: column;
    height: 100%;
}

.inner-content::-webkit-scrollbar {
    display: none;
}

.inner-content {
    background: white;
    border-radius: 10px;
    position: relative;
    display: flex;
    flex-direction: column;
    overflow: scroll;
    box-shadow: 0 3px 4px 0 rgb(0 0 0 / 30%);
    padding-bottom: 16px;
}

.place_img {
    width: auto;
    height: 70px;
    margin-top: 24px;
    margin-left: auto;
    margin-right: auto;
    box-sizing: border-box;
    display: flex;
    justify-content: center;
}

.place_img img {
    width: auto;
    height: 70px;
    object-fit: cover;
}

.main_title {
    margin-top: 24px;
    font-size: 19px;
    margin-left: 24px;
    margin-right: 24px;
    text-align: center;
}

.subtitle {
    margin-top: 4px;
    font-size: 16px;
    margin-left: 16px;
    margin-right: 16px;
    text-align: center;
}

.bottom-space {
    margin-bottom: 8px;
}

.profile-photo {
    align-self: end;
    position: absolute;
    width: 36px;
    height: 36px;
    top: 12px;
    right: 12px;
}

.scan_qrs_button {
    background: #727272;
    border-radius: 4px;
    margin-left: 16px;
    margin-right: 16px;
    margin-bottom: 16px;
    margin-top: 16px;
    color: white;
    height: 44px;
    min-height: 44px;
    display: flex;
    font-size: 18px;
    align-items: center;
    justify-content: center;
    box-shadow: 0 3px 4px 0 rgb(0 0 0 / 30%);
    cursor: pointer;
    max-width: 400px;
}
.main_button {
    background: #B95E5E;
    border-radius: 4px;
    margin-left: 16px;
    margin-right: 16px;
    margin-bottom: 16px;
    margin-top: 16px;
    color: white;
    height: 44px;
    min-height: 44px;
    display: flex;
    font-size: 18px;
    align-items: center;
    justify-content: center;
    box-shadow: 0 3px 4px 0 rgb(0 0 0 / 30%);
    cursor: pointer;
    max-width: 400px;
}

.input-wrapper {
    margin-left: 16px;
    margin-right: 16px;
    margin-top: 16px;
    width: auto;
    margin-bottom: 0;
}

.input-wrapper.input {
    margin-top: 32px;
}

.input-wrapper.notes {
    margin-top: 28px;
}

.input-wrapper.notes .form-control {
    padding-right: 80px;
}

.input-wrapper.additional {
    display: flex;
    flex-direction: column;
}
.input-wrapper .dropdown-label {
    font-size: 14px;
}

.checkbox-wrapper {
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-left: 16px;
    margin-right: 16px;
    font-size: 15px;
    margin-top: 16px;
}

.checkbox-wrapper span {
    margin-left: 4px;
    margin-top: 5px;
    width: 100%;
    cursor: pointer;
}

.comment_btn__wrapper.photo {
    position: absolute;
    right: 8px;
    bottom: 7px;
    cursor: pointer;
}

.preview {
    height: 50px;
    padding-top: 4px;
    margin-left: 16px;
    margin-right: 16px;
    margin-bottom: 10px;
}

.preview img {
    max-width: 100%;
    max-height: 50px;
    padding-right: 5px;
}

.audio_wrapper {
    margin-top: 10px;
    display: flex;
    align-items: center;
    flex-direction: row;
    margin-left: 16px;
    margin-right: 16px;
}

audio {
    width: 90%;
    height: 40px;
}

.audio_delete {
    margin-left: 6px;
    cursor: pointer;
    padding: 6px;
}

/*________*/


input[type="checkbox"] {
    width: auto;
    margin-left: 0;
}

.input-label.dropdown {
    top: -14px !important;
    transition: all .3s ease;
    font-size: 14px;
}

.input-label {
    position: absolute;
    z-index: 999;
    top: 10px;
    pointer-events: none;
    transition: all .3s ease;
}

input:not(:placeholder-shown) ~ .input-label,
input:focus ~ .input-label {
    top: -15px;
    transition: all .3s ease;
    font-size: 14px;
}

.form-control {
    position: relative;
    border: none;
    border-bottom: 1px solid #2F2F2F;
    outline: none;
    border-radius: 0;
    padding-left: 0;
    font-size: 16px;
    line-height: 22px;
    font-weight: 700;
    color: black;
}

.form-control:focus {
    outline: none !important;
    text-decoration: none;
    box-shadow: none;
    border-color: #2F2F2F;
    color: black;
}

input::-webkit-calendar-picker-indicator {
    display: none;
}

.form-control::placeholder {
    font-size: 14px;
    color: #2F2F2F;
}

.form-control.simple::placeholder {
    font-size: 16px;
    color: #cdcdcd;
}

.form-control.simple {
    margin-top: 4px;
}

.photo-modal__wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
}

.photo-modal__image img {
    max-width: 100%;
    max-height: 250px;
}

.photo-modal__buttons {
    display: flex;
    justify-content: center;
    margin-top: 35px;
}

.photo-modal__change {
    border: 2px solid #3F405C;
    box-sizing: border-box;
    border-radius: 6px;
    padding: 12px;
    font-size: 16px;
    cursor: pointer;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    margin-right: 25px;
}

.photo-modal__delete {
    width: 100%;
    box-sizing: border-box;
    border-radius: 6px;
    padding: 12px;
    font-size: 16px;
    cursor: pointer;
    color: #FFFFFF;
    background-color: #3F405C;
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
}

.content__wrapper {
    display: flex;
    justify-content: space-around;
    padding-top: 16px;
    width: 100%;
}

.rectangle-wrapper {
    margin-left: 16px;
    margin-right: 16px;
    width: 100%;
    cursor: pointer;
}

.rectangle {
    background: #FFFFFF;
    border-radius: 12px;
    padding: 1px;
    display: flex;
    flex-direction: column;
    align-items: center;
    box-sizing: border-box;
    position: relative;
    justify-content: center;
    height: 100%;
    box-shadow: 0 3px 4px 0 rgb(0 0 0 / 30%);
    aspect-ratio: 1;
    max-width: 100%;
    background-size: cover !important;
    background-repeat: no-repeat !important;
    background-position: center !important;
}
.rectangle-wrapper.left {
    margin-right: 8px;
}

.rectangle-wrapper.right {
    margin-left: 8px;
}

.rectangle.active {
    /*padding: 0;*/ /* ? removed to avoid text jumping when no icon and selected*/
}
.rectangle_img {
    max-width: 85px;
    max-height: 85px;
    margin-bottom: 20px;
}
.rect_btn_img {
    max-width: 60px;
    max-height: 60px;
    margin-bottom: 16px;
}
.check_icon {
    position: absolute;
    max-width: 32px;
    top: 2px;
    left: 5px;
}
.rect_close {
    max-width: 40px;
    position: absolute;
    top: 0;
    right: 0;
    padding-top: 12px;
    padding-right: 12px;
    padding-left: 8px;
    padding-bottom: 8px;
}
.rect_close_back {
    width: 32px;
    height: 32px;
    position: absolute;
    aspect-ratio: 1;
    top: 6px;
    right: 6px;
    /*background: rgba(185, 94, 94, 0.40);*/
    background: rgb(131, 131, 131, 0.40);
    border-radius: 4px;
}

.rectangle-text {
    position: absolute;
    font-weight: bold;
    font-size: 17px;
    line-height: 18px;
    padding-top: 5px;
    padding-right: 10px;
    padding-bottom: 5px;
    margin-bottom: 7px;
    padding-left: 10px;
    text-align: center;
    /*white-space: nowrap;*/
    text-overflow: ellipsis;
    overflow: hidden;
    max-width: 96%;
    color: #424242;
    bottom: 0;
    border-radius: 4px;
}
.rectangle-text.active {
    color: #ffffff;
}

.rectangle-text__noicon {
    font-weight: bold;
    font-size: 20px;
    line-height: 24px;
    padding: 5px 5px 5px;
    text-align: center;
    text-overflow: ellipsis;
    word-break: break-word;
    overflow: hidden;
    max-width: 100%;
}

.rectangle-subtitle {
    font-weight: normal;
    font-size: 16px;
    line-height: 16px;
    padding: 5px 5px 5px;
    text-align: center;
    text-overflow: ellipsis;
    word-break: break-word;
    overflow: hidden;
    max-width: 100%;
}


@media screen and (min-width: 532px) {
    .content {
        margin: auto;
    }
}

@media screen and (min-width: 464px) {
    .main_button {
        margin-left: auto;
        margin-right: auto;
        min-width: 400px;
    }
}

@media screen and (max-width: 320px) {
    .rectangle-text {
        font-size: 14px;
        line-height: 14px;
        margin-bottom: 5px;
    }
    .rectangle_img {
        max-width: 70px;
        max-height: 70px;
    }
    .check_icon {
        max-width: 25px;
    }
}

@keyframes pulse {
    0% {
        box-shadow: 0px 0px 5px 0px rgba(173, 0, 0, .3);
    }
    65% {
        box-shadow: 0px 0px 5px 10px rgba(173, 0, 0, .3);
    }
    90% {
        box-shadow: 0px 0px 5px 10px rgba(173, 0, 0, 0);
    }
}
</style>
